import { createI18nInstance } from '/utilities/i18n';

export const getEmptyLocation = (language) => {
	const { t } = createI18nInstance(language);

	return {
		city: undefined,
		shortTitle: t('Tüm Şehirler'),
		label: t('Tüm Şehirler'),
		title: t('Tümü'),
		slug: 'tumu',
		address: null,
		phone: null,
		email: null,
		id: false,
		location: null,
		value: false,
	};
};

export const emptyLocation = getEmptyLocation();

export default emptyLocation;